<div class="container">
  <h3 class="label" [fxShow.xs]="false" [fxShow.sm]="false">Recherche :</h3>

  <form class="form">
    <mat-form-field appearance="fill">
      <input type="text" placeholder="Saisir ici le client ou dossier recherché " matInput [formControl]="control" [matAutocomplete]="auto" />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="open()">
        <mat-option *ngFor="let option of data" [value]="option"> {{ option.name }} ({{ option.templateReference_pop.name }}) </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <div class="button">
    <button mat-raised-button color="primary" (click)="open()" matTooltip="Visualiser la sélection">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
